import { Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-zoom-video',
    templateUrl: './zoom-video.component.html',
    styleUrls: ['./zoom-video.component.css']
})
export class ZoomVideoComponent implements OnInit {
    @Input() userName: string;
    @Input() token: string;
    @Input() sessionName: string
    @Input() idEpisode: number;
    @Input() idPatientAppointment: number;
    @Output() leaveRoom = new EventEmitter<boolean>();

    isMuted: boolean = false;
    public leaveSession: Function;

    sessionContainer;
    wrapperContainer;
    controlsContainer;
    videoContainer;
    chatContainer;
    private uiToolkit;
    private translationObserver: MutationObserver | null = null;

    constructor(public zone: NgZone,) { }

    ngOnInit(): void {
        this.leaveSession = this.sessionClosed.bind(this)
    }

    async ngAfterContentInit(): Promise<void> {
        this.zone.runOutsideAngular(async () => {
            const toolkit = (await import('@zoom/videosdk-ui-toolkit')).default;
            this.uiToolkit = toolkit;
        }).then(() => {
            this.startUIToolKit();
        });
    }

    startUIToolKit() {
        var config = {
            videoSDKJWT: this.token,
            sessionName: this.sessionName,
            userName: this.userName,
            sessionPasscode: this.idEpisode ? this.idEpisode.toString() : this.idPatientAppointment.toString(),
            features: ['video', 'audio',],
            options: { init: {}, audio: {}, video: {}, share: {} },
            virtualBackground: {
                allowVirtualBackground: true,
                allowVirtualBackgroundUpload: true,
                virtualBackgrounds: [
                    'https://images.unsplash.com/photo-1715490187538-30a365fa05bd?q=80&w=1945&auto=format&fit=crop'
                ]
            }
        }

        this.sessionContainer = document.getElementById('sessionContainer');

        try {
            this.uiToolkit.joinSession(this.sessionContainer, config);
            this.uiToolkit.onSessionClosed(this.leaveSession)
            this.uiToolkit.onSessionJoined(this.sessionJoined)
            const translations: Record<string, string> = {
                "Action Required": "Ação Necessária",
                "Click the button below to enable audio.": "Clique no botão abaixo para ativar o áudio.",
                "Enable Audio": "Ativar Áudio",
                "No one present": "Nenhum participante presente",
                "Mute": "Silenciar",
                "Unmute": "Reativar Áudio",
                "Join Audio": "Conectar Áudio",
                "left the session": "saiu da sessão.",
                "joined the session.": "entrou na sessão.",
                "Leave": "Finalizar atendimento"
            };

            const replaceIfEquals = (el: HTMLElement | null, eng: string, pt: string) => {
                if (!el) return false;
                const text = el.innerText?.trim();
                if (text === eng) {
                    el.innerText = pt;
                    return true;
                }
                return false;
            };

            const applyTranslations = () => {
                document.querySelectorAll('h3.mat-mdc-dialog-title').forEach(n => {
                    replaceIfEquals(n as HTMLElement, 'Action Required', translations['Action Required']);
                });

                document.querySelectorAll('.mat-mdc-dialog-content p').forEach(n => {
                    replaceIfEquals(n as HTMLElement, 'Click the button below to enable audio.', translations['Click the button below to enable audio.']);
                });

                document.querySelectorAll('.mat-mdc-dialog-actions .mdc-button__label').forEach(n => {
                    replaceIfEquals(n as HTMLElement, 'Enable Audio', translations['Enable Audio']);
                });

                document.querySelectorAll('.mat-mdc-card-content').forEach(n => {
                    const el = n as HTMLElement;
                    if (el.innerText?.trim().includes('No one present')) {
                        el.innerText = translations['No one present'];
                    }
                });
                document.querySelectorAll('.mat-mdc-snack-bar-label').forEach(n => {
                    const el = n as HTMLElement;
                    const text = el.innerText?.trim();
                    if (!text) return;
                    if (text.endsWith('left the session.')) {
                        el.innerText = text.replace('left the session.', translations['left the session']);
                    } else if (text.endsWith('joined the session.')) {
                        el.innerText = text.replace('joined the session.', translations['joined the session.']);
                    }
                });
                document.querySelectorAll('.mat-mdc-menu-item-text').forEach(n => {
                    const el = n as HTMLElement;
                    const txt = el.innerText?.trim();
                    if (!txt) return;
                    if (txt === 'Leave') {
                        el.innerText = translations['Leave'];
                    } else if (txt === 'End') {
                        const menuItem = el.closest('.mat-mdc-menu-item') as HTMLElement | null;
                        if (menuItem) {
                            menuItem.remove();
                        }
                    }
                });

                document.querySelectorAll('.mdc-button__label').forEach(n => {
                    const el = n as HTMLElement;
                    replaceIfEquals(el, 'Mute', translations['Mute']);
                    replaceIfEquals(el, 'Unmute', translations['Unmute']);
                    replaceIfEquals(el, 'Join Audio', translations['Join Audio']);
                });
            };

            applyTranslations();

            this.translationObserver = new MutationObserver((mutations) => {
                applyTranslations();
            });

            if (this.sessionContainer)
                this.translationObserver.observe(this.sessionContainer, { childList: true, subtree: true });

        } catch (error) {
            console.log(error);
        }
    }

    sessionJoined() {
    }

    sessionClosed = () => {
        this.leaveRoom.emit(true);
        if (this.uiToolkit && this.sessionContainer) {
            this.uiToolkit.closeSession(this.sessionContainer);
        }
    };

    ngOnDestroy(): void {
        if (this.translationObserver) {
            this.translationObserver.disconnect();
            this.translationObserver = null;
        }
    }

    onLeaveSession() {
        if (this.uiToolkit) {
            this.uiToolkit.offSessionClosed(this.sessionClosed);
            if (this.sessionContainer) this.uiToolkit.closeSession(this.sessionContainer);
        }
    }
}
